module.exports = __webpack_public_path__ + "static/img/moment6.7936275.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/moment6.png
// module id = 99rS
// module chunks = 1